import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import errorLogger from './monitoring/errorLogger'

const apiUrl = process.env.REACT_APP_MS_API_BASE_URL || ''

let axiosInstance: AxiosInstance | null = null

export default (
  createNew?: boolean,
  options?: AxiosRequestConfig,
): AxiosInstance => {
  if (axiosInstance && !createNew) return axiosInstance as AxiosInstance

  axiosInstance = axios.create({
    baseURL: apiUrl,
    timeout: 20000,
    headers: {
      Accept: 'application/json',
      'Client-Device': 'app',
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      'source-version': 'v1',
    },
    ...options,
  })

  axiosInstance.interceptors.request.use(
    function (config) {
      // console.log('RESPONSE ON REQ INTERCEPTOR ', config)
      return config
    },
    function (error) {
      errorLogger.captureHTTPException(error)
    },
  )

  axiosInstance.interceptors.response.use(
    function (response) {
      // console.log('RESPONSE ON RES INTERCEPTOR ', response)
      return response
    },
    function (error) {
      errorLogger.captureHTTPException(error)

      const status = error?.response?.status
      if (status === 401 || status === 403) {
        axiosInstance = null
        localStorage.clear()
        document.location.reload()
      }
    },
  )

  return axiosInstance
}
